import {
  DefaultLayout,
  WidgetSpecType,
  widgetRegistry,
} from '@erecruit/modules';
import { createGuid, Intl } from '@erecruit/core';
import { tableWidgets } from './tableWidget';

const counterWidthHeightConstraints =
  widgetRegistry[WidgetSpecType.counter].sizeConstraints;
const tableWidthHeightConstraints =
  widgetRegistry[WidgetSpecType.table].sizeConstraints;

const widgetIds = {
  'Counter.Positions.Open': createGuid(),
  'Counter.Matches.Submittals': createGuid(),
  'Counter.Matches.Working': createGuid(),
  'Counter.Positions.Closed': createGuid(),
  'Counter.Shifts.Filled': createGuid(),
  'Counter.Shifts.UnFilled': createGuid(),
  'Table.Matches.Submittals': createGuid(),
};

export const getDefaultLayout = (intl: Intl.InjectedIntl): DefaultLayout => ({
  widgetItems: [
    {
      id: widgetIds['Counter.Positions.Open'],
      widgetId: 'Counter.Positions.Open',
      dynamicWidgetArgs: {
        title: intl.formatMessage({
          id: messageIds.modules.widget.counterWidget.openPositions,
        }),
      },
      type: WidgetSpecType.counter,
    },
    {
      id: widgetIds['Counter.Matches.Submittals'],
      widgetId: 'Counter.Matches.Submittals',
      dynamicWidgetArgs: {
        title: intl.formatMessage({
          id: messageIds.modules.widget.counterWidget.submittedMatches,
        }),
      },
      type: WidgetSpecType.counter,
    },
    {
      id: widgetIds['Counter.Matches.Working'],
      widgetId: 'Counter.Matches.Working',
      dynamicWidgetArgs: {
        title: intl.formatMessage({
          id: messageIds.modules.widget.counterWidget.currentlyWorkingMatches,
        }),
      },
      type: WidgetSpecType.counter,
    },
    {
      id: widgetIds['Counter.Positions.Closed'],
      widgetId: 'Counter.Positions.Closed',
      dynamicWidgetArgs: {
        title: intl.formatMessage({
          id: messageIds.modules.widget.counterWidget.closedPositions,
        }),
      },
      type: WidgetSpecType.counter,
    },
    {
      id: widgetIds['Counter.Shifts.Filled'],
      widgetId: 'Counter.Shifts.Filled',
      dynamicWidgetArgs: {
        title: intl.formatMessage({
          id: messageIds.modules.widget.counterWidget.filledShifts,
        }),
      },
      type: WidgetSpecType.counter,
    },
    {
      id: widgetIds['Counter.Shifts.UnFilled'],
      widgetId: 'Counter.Shifts.UnFilled',
      dynamicWidgetArgs: {
        title: intl.formatMessage({
          id: messageIds.modules.widget.counterWidget.unfilledShifts,
        }),
      },
      type: WidgetSpecType.counter,
    },
    {
      id: widgetIds['Table.Matches.Submittals'],
      widgetId: 'Table.Matches.Submittals',
      dynamicWidgetArgs: {
        title: intl.formatMessage({
          id: messageIds.modules.widget.tableWidget.submittedMatches,
        }),
        visibleColumns:
          tableWidgets.find(
            widget => widget.widgetId === 'Table.Matches.Submittals',
          )?.columns || [],
      },
      type: WidgetSpecType.table,
    },
  ],
  widgetLayouts: [
    {
      i: widgetIds['Counter.Positions.Open'],
      w: 3,
      h: 3,
      x: 0,
      y: 0,
      ...counterWidthHeightConstraints,
    },
    {
      i: widgetIds['Counter.Matches.Submittals'],
      w: 3,
      h: 3,
      x: 3,
      y: 0,
      ...counterWidthHeightConstraints,
    },
    {
      i: widgetIds['Counter.Matches.Working'],
      w: 3,
      h: 3,
      x: 6,
      y: 0,
      ...counterWidthHeightConstraints,
    },
    {
      i: widgetIds['Counter.Positions.Closed'],
      w: 3,
      h: 3,
      x: 0,
      y: 3,
      ...counterWidthHeightConstraints,
    },
    {
      i: widgetIds['Counter.Shifts.Filled'],
      w: 3,
      h: 3,
      x: 3,
      y: 3,
      ...counterWidthHeightConstraints,
    },
    {
      i: widgetIds['Counter.Shifts.UnFilled'],
      w: 3,
      h: 3,
      x: 6,
      y: 3,
      ...counterWidthHeightConstraints,
    },
    {
      i: widgetIds['Table.Matches.Submittals'],
      w: 9,
      h: 9,
      x: 0,
      y: 6,
      ...tableWidthHeightConstraints,
    },
  ],
});
